export default __webpack_public_path__ + "media/images/backgrounds/wind_turbine-4ffc181620f7ad82c2e4563ab6e75a8a.gif";